import React from 'react';

/** Figma Total Hours Logged sparkline (node 40004505:19226) */
const FIGMA_DEFAULT_BARS = [24, 28, 20, 40, 32, 41, 36, 47];
const CHART_HEIGHT = 64;
const MIN_BAR_PX = 12;

/**
 * MiniBarChart
 * ------------------------------------------------------------------
 * Small decorative bar chart used inline in a KPI card (e.g. Total
 * Hours Logged). Values are normalized against the tallest bar so
 * any raw numbers can be passed directly. Empty data falls back to
 * the Figma sparkline proportions.
 *
 * @param {number[]} values
 * @param {'blue'|'purple'|'green'} tone
 */
const MiniBarChart = ({ values = [], tone = 'blue', className = '' }) => {
  const source =
    Array.isArray(values) && values.length > 0 ? values : FIGMA_DEFAULT_BARS;
  const max = Math.max(...source.map((v) => Number(v) || 0), 1);

  return (
    <div
      className={`mini-bar-chart mini-bar-chart--${tone} ${className}`.trim()}
      aria-hidden="true"
    >
      {source.map((value, index) => {
        const raw = Number(value) || 0;
        const heightPx = Math.max(MIN_BAR_PX, Math.round((raw / max) * CHART_HEIGHT));
        return (
          <span
            key={index}
            className="mini-bar-chart__bar"
            style={{ height: `${heightPx}px` }}
          />
        );
      })}
    </div>
  );
};

export default MiniBarChart;
